document.addEventListener("DOMContentLoaded", function () {
  $(".AppMfaSmsSetupSmsNumberConfirmations--new").ready(function () {
    $(".form-container").autoFadeIn();
  });
});
